import { useEffect, useState, useCallback, useRef, useReducer } from 'react';
import { useLocation, useNavigate as useHistory, useSearchParams, useParams } from 'react-router-dom';
import ReportHead from 'components/reportHead';
import { AntdTableScrollXaxisTop } from 'antd-table-scroll-xaxis-top';
import {
  DatePicker,
  Tag,
  Pagination,
  Table,
  notification,
  AutoComplete,
  Select,
  Button,
  Spin
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import DownloadService from 'services/download';
import { Input, Space, Empty, ConfigProvider } from 'antd';
import { Form } from 'react-bootstrap';
import moment from 'moment';
import Utils from 'utils';
const { RangePicker } = DatePicker;
import { ArrowLeftOutlined } from '@ant-design/icons';
import {
  faFilePdf,
  faFileExcel,
  faFileCode,
  faFileLines,
  faCircleQuestion
} from '@fortawesome/free-regular-svg-icons';
import {
  faCircleInfo,
  faArrowDownAZ,
  faArrowDownZA,
  faArrowDown91,
  faArrowUp19,
  faArrowDown19
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './newReportCompiler.scss';
import { useSpoolData } from '../../services/SpoolData';
import { useGetAutocomplete } from '../../services/GetAutocomplete';
import { useGetReportDownload } from '../../services/GetReportDownload';
import { downloadFile } from '../../assets/extra/helpers';
import IsMobile from 'components/IsMobile/IsMobile';
import { useDispatch, useSelector } from 'react-redux';
import {
  initialState as Is_newReportCompiler,
  updateFilters,
  updateData,
  updateTextFilters,
  updateTableData
} from '../../redux/reducers/NewReportCompiler.reducer';
import { useGetFunzione } from '../../services/GetFunzione';
import { getLanguage } from '../langSelector/LangSelector';

const BodyCompiler = ({ mainTitle }) => {
  const getReportDownload = useGetReportDownload();
  const getSpoolData = useSpoolData();
  const getAutocompleteData = useGetAutocomplete();
  const history = useHistory();
  const [searchParams, setSearchParams] = useSearchParams();
  const getFunzione = useGetFunzione();
  const language = getLanguage();
  const location = useLocation();
  const {
    state = {
      dataDa: undefined,
      dataA: undefined,
      funzione: undefined,
      title: undefined,
      periodoDate: undefined,
      mainTitle: undefined,
      percorsoBk: undefined,
      isEditable: true,
      fromHome: undefined,
      homeDataPicker: undefined,
      descrizione: undefined,
      metadati_val: undefined,

      caller_state: undefined
    }
  } = useLocation();
  const {
    dataDa,
    dataA,
    title,
    periodoDate,
    percorsoBk,
    isEditable,
    fromHome,
    homeDataPicker,
    descrizione,
    metadati_val,

    caller_state
  } = state || {};

  const dispatch = useDispatch();
  const LF = 'DD/MM/YYYY';
  const LF_API = 'YYYY-MM-DD';
  const [paginationHelper, setPaginationHelper] = useState(true);
  const [selectedPage, setSelectedPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [currFilterValue, setCurrFilterValue] = useState(null);
  const [currColumnSearch, setCurrColumnSearch] = useState('');
  const [currColumnValue, setCurrColumnValue] = useState('');
  const [currColumnDataIndex, setCurrColumnDataIndex] = useState('');

  const [tmpDates, setTmpDates] = useState({ dataDaUp: null, dataAUp: null });
  const [data, setData] = useState({ dataDaUp: null, dataAUp: null });
  const [autoData, setAutoData] = useState([]);
  const [autoDataFiltered, setAutoDataFiltered] = useState(null);
  const [autocompleteIsLoading, setAutocompleteIsLoading] = useState(true);
  const [searchIsLoading, setSearchIsLoading] = useState(false);
  const [tempDesc, setTempDesc] = useState(descrizione);
  const [tempSubTitle, setTempSubTitle] = useState(title);
  const [tempPeriodoDate, setTempPeriodoDate] = useState(periodoDate);
  const [headerFunction, setHeaderFunction] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [loadingXLSX, setLoadingXLSX] = useState(false);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [loadingJSON, setLoadingJSON] = useState(false);
  const [funzione, setFunzione] = useState(null);

  const { filters, textFilters, tableData } = useSelector(
    (reduxState) => reduxState.NewReportCompiler
  );

  useEffect(() => {
    setPaginationHelper(true);
  }, [paginationHelper]);

  //useEffect(() => {
  //  GetTableData({ selectedPage });
  //}, []);

  useEffect(() => {
    setTempDesc(tempDesc);
    setTempSubTitle(title || tempSubTitle);
    setTempPeriodoDate(periodoDate || tempPeriodoDate);
  }, [descrizione, title, periodoDate]);

  const paginationChange = (pagina, pageSize) => {
    setSelectedPage(pagina);
    setPageSize(pageSize);
  };

  const loadFunzione = async () => {
    let pDates = { dataDaUp: null, dataAUp: null };
    if (searchParams.has('dateFrom')) {
      pDates.dataDaUp = searchParams.get('dateFrom');
    }

    if (searchParams.has('dateTo')) {
      pDates.dataAUp = searchParams.get('dateTo');
    }

    setTmpDates(() => pDates);
    setData(() => pDates);

    let param = {};
    if (searchParams.has('id')) {
      param.id = +searchParams.get('id');
      if (funzione?.id != param.id) {
        let res = await getFunzione.execute({
          funzione: param.id,
          plang: language,
          dateFrom: pDates.dataDaUp,
          dateTo: pDates.dataAUp
        });

        if (!res?.items?.length) {
          goBack();
          return;
        }

        res = res.items[0];
        param.loaded = true;
        param.title = res.titolo_report;
        param.funzione = param.titolo_report;
        param.periodoDate = res.periodo_dati;
        param.descrizione = res.descrizione_report;
        param.tipoAnalisiTemporale = res.tipo_analisi_temporale;
        let perDate = [];
        perDate.push(res.periodo_dati_da);
        let dtTo = moment(res.periodo_dati_a, 'DD/MM/YYYY');
        let dtNow = moment();
        if (dtTo > dtNow) {
          dtTo = dtNow;
        }

        perDate.push(dtTo.format('DD/MM/YYYY'));
        setTempPeriodoDate(() => perDate);
        setFunzione(() => param);
        setTempDesc(() => param.descrizione);
        setTempSubTitle(() => param.title);
      }
    } else {
      goBack();
    }
  };

  useEffect(async () => {
    await loadFunzione();
  }, [location]);

  useEffect(async () => {
    if (funzione) {
      let chkDt = checkSearchDates();
      if (chkDt) {
        setTmpDates({
          ...tmpDates,
          dataDaUp: chkDt.dataDaUp,
          dataAUp: chkDt.dataAUp
        });
        updateUrlParam(chkDt);
      } else {
        await GetTableData({ selectedPage });
      }
    }
  }, [selectedPage, pageSize, filters, textFilters.filterFields, funzione, data]);

  useEffect(() => {}, [data]);

  const checkSearchDates = () => {
    let pDates = { dataDaUp: data.dataDaUp, dataAUp: data.dataAUp };
    let hasErrors = false;
    let ret = { dateFrom: pDates.dataDaUp, dateTo: pDates.dataAUp };
    let d = pDates.dataDaUp;
    if (d) {
      d = moment(d, 'YYYY-MM-DD', true);
      if (d.isValid()) {
        if (d.isBefore(moment(tempPeriodoDate[0], 'DD/MM/YYYY'))) {
          hasErrors = true;
          ret.dateFrom = moment(tempPeriodoDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
        } else if (d.isAfter(moment(tempPeriodoDate[1], 'DD/MM/YYYY'))) {
          hasErrors = true;
          ret.dateFrom = moment(tempPeriodoDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
      } else {
        hasErrors = true;
        ret.dateFrom = moment(tempPeriodoDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    } else {
      hasErrors = true;
      ret.dateFrom = moment(tempPeriodoDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    d = pDates.dataAUp;
    if (d) {
      if (funzione.tipoAnalisiTemporale?.toUpperCase() == 'DATA') {
        hasErrors = true;
        ret.dateTo = null;
      } else {
        d = moment(d, 'YYYY-MM-DD', true);
        if (d.isValid()) {
          if (d.isBefore(moment(tempPeriodoDate[0], 'DD/MM/YYYY'))) {
            hasErrors = true;
            ret.dateTo = moment(tempPeriodoDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
          } else if (d.isAfter(moment(tempPeriodoDate[1], 'DD/MM/YYYY'))) {
            hasErrors = true;
            ret.dateTo = moment(tempPeriodoDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
          }
        } else {
          hasErrors = true;
          ret.dateTo = moment(tempPeriodoDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
      }
    } else if (funzione.tipoAnalisiTemporale?.toUpperCase() == 'PERIODO') {
      hasErrors = true;
      ret.dateTo = moment(tempPeriodoDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    if (ret.dateTo) {
      d = moment(ret.dateFrom, 'YYYY-MM-DD');
      let dTo = moment(ret.dateTo, 'YYYY-MM-DD');
      if (d.isAfter(dTo)) {
        hasErrors = true;
        ret.dateTo = ret.dateFrom;
      }
    }

    if (hasErrors) {
      return ret;
    }

    return null;
  };

  const GetReportDownload = async (file = null) => {
    const { dataDaUp, dataAUp } = data;
    const downloadFileData = await getReportDownload.execute(
      {
        orderFields: [],
        orderDirects: [],
        pFilterFields: textFilters.filterFields.map((field) => field.textFields),
        pFilterValues: textFilters.filterFields.map((field) => field.textValue)
      },
      `/${dataDaUp}/${funzione?.id}?${dataAUp != undefined ? `&dataA=${dataAUp}` : ``}&pdoctype=${file}`
    );
    downloadFile(downloadFileData, downloadFileData.filename ? downloadFileData.filename : `${title}.${file}`);
  };

  const GetAutocompleteData = async (currColumnDataIndex) => {
    setCurrColumnSearch('');
    setAutoDataFiltered(null);
    setAutoData([]);
    setSearchIsLoading(true);
    setAutocompleteIsLoading(true);
    if (currColumnDataIndex) {
      const { dataDaUp, dataAUp } = data;
      const autocompleteData = await getAutocompleteData.execute(
        {
          orderFields: [],
          orderDirects: [],
          pFilterFields: textFilters.filterFields.map((field) => field.textFields),
          pFilterValues: textFilters.filterFields.map((field) => field.textValue)
        },
        `/${dataDaUp}/${funzione?.id}?&PageNum=1&PageSize=999999${
          dataAUp != undefined ? `&dataA=${dataAUp}` : ``
        }&plovfield=${currColumnDataIndex}`
      );
      const tmpData = autocompleteData.body?.map((e, idx) => {
        return {
          value: (e[currColumnDataIndex] || e[currColumnDataIndex] == 0 ? e[currColumnDataIndex].toString() : null),
          label: (e[currColumnDataIndex] || e[currColumnDataIndex] == 0 ? e[currColumnDataIndex].toString() : null),
          key: (e[currColumnDataIndex] || e[currColumnDataIndex] == 0 ? `auto-${e[currColumnDataIndex].toString()}-${idx}` : `empty-${idx}`)
        };
      });
      setAutoData(tmpData);
      setAutocompleteIsLoading(false);
    }
    setSearchIsLoading(false);
  };

  const GetTableData = async ({ selectedPage }) => {
    const { dataDaUp, dataAUp } = data;
    let filteredOrderFields = [];
    let filteredOrderDirects = [];
    filters.orderDirects.forEach((value, index) => {
      if (value){
        filteredOrderFields = [...filteredOrderFields, filters.orderFields[index]];
        filteredOrderDirects = [...filteredOrderDirects, value];
      }
    });
    const table = await getSpoolData.execute(
      {
        orderFields: filteredOrderFields,
        orderDirects: filteredOrderDirects,
        pFilterFields: textFilters.filterFields.map((field) => field.textFields),
        pFilterValues: textFilters.filterFields.map((field) => field.textValue)
      },
      `/${dataDaUp}/${funzione?.id}?&PageNum=${selectedPage}&PageSize=${pageSize}${
        dataAUp != undefined ? `&dataA=${dataAUp}` : ``
      }`
    );
    dispatch(updateTableData(table));
  };

  const FilterColumns = async (column, keyDownEvent) => {
    if (!keyDownEvent || keyDownEvent === "Enter"){
      const { orderFields, orderDirects } = filters;
      let tmpOrderFields = [...orderFields];
      let tmpOrderDirects = [...orderDirects];
      const i_ = tmpOrderFields.findIndex((field) => field === column);
      // caso 0 - nuova entry -> DESC
      if (i_ === -1) {
        tmpOrderFields = [...tmpOrderFields, column];
        tmpOrderDirects = [...tmpOrderDirects, 'DESC'];
      } else {
        switch (tmpOrderDirects[i_]) {
          // caso 1 - DESC -> ASC
          case 'DESC':
            tmpOrderDirects[i_] = 'ASC';
            break;
          // caso 2 - ASC -> nessun ordinamento
          case 'ASC':
            tmpOrderDirects[i_] = '';
            break;
          // caso 3 - nessun ordinamento -> DESC      
          default:
            tmpOrderDirects[i_] = 'DESC';
            break;
        }
      }

      dispatch(
        updateFilters({
          orderFields: tmpOrderFields,
          orderDirects: tmpOrderDirects
        })
      );
    }
  };

  const columns = tableData.colNames.map((column, index) => {
    return {
      title: tableData.label[index],
      dataIndex: column,
      key: column,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => <></>,
      filterIcon: (filtered) => (
        <span
          tabIndex="0"
          onClick={() => {
            FilterColumns(column);
          }}
          onKeyDown={(e) => {
            FilterColumns(column, e.key);
          }}>
          <FontAwesomeIcon aria-hidden="false" alt="" icon={getIconByDataIndex(column, index)} className={getColorByActive(column)} />
        </span>
      ),
      align: tableData.types[index] == 'VARCHAR' ? 'Pagina precedente' : 'Pagina successiva'
    };
  });
  const selectOption = tableData.label.map((e, i) => {
    return { value: tableData.colNames[i], label: e };
  });

  const getIconByDataIndex = (dataIndex = '', index) => {
    const { orderFields, orderDirects } = filters;
    const i_ = orderFields?.findIndex((field) => field === dataIndex);

    if (orderDirects[i_] === 'ASC')
      return tableData.types[index] == 'VARCHAR' ? faArrowDownAZ : faArrowDown19;
    else return tableData.types[index] == 'VARCHAR' ? faArrowDownZA : faArrowDown91;
  };
  const getColorByActive = (dataIndex = '') => {
    const { orderFields, orderDirects } = filters;
    const i_ = orderFields.findIndex((field) => field === dataIndex);
    return orderDirects[i_] === 'DESC' || orderDirects[i_] === 'ASC'  ? 'activeOrder' : 'defaultIconOrder';
  };

  const updateUrlParam = (nextInit) => {
    const newSearchParams = new URLSearchParams(searchParams);

    for (var i in nextInit) {
      if (nextInit[i] != null) {
        newSearchParams.set(i, nextInit[i]);
      } else {
        newSearchParams.delete(i);
      }
    }

    // Update the URL with the new search parameters
    setSearchParams(newSearchParams, { state: state });
  };

  const goBack = () => {
    if (!fromHome) {
      history(`${percorsoBk || '..'}`, { state: caller_state });
    } else history(`/home`);
  };

  const isChangingDateFilter = () => {
    const { dataDaUp, dataAUp } = tmpDates;
    return dataDaUp !== data.dataDaUp || dataAUp !== data.dataAUp;
  };

  return (
    <Spin spinning={!funzione}>
      <div>
        <button
          style={{marginBottom: '15px'}}
          tabIndex="0"
          aria-hidden="arrow-left"
          id="TornaIndietro-btn"
          onClick={goBack}>
          <ArrowLeftOutlined />
          <span>Indietro</span>
        </button>
      </div>
      <div id="reportTitles">
        <div className="titleDownload">
          {(mainTitle || state?.mainTitle) && <h2 style={{marginTop: '0px'}}>{mainTitle || state?.mainTitle}</h2>}
              </div>
        <div className="titleDownload">
              {tempSubTitle && <h3>{tempSubTitle}</h3>}
          <div id="downloadBtnDiv">
            <Button
              tabIndex="0"
              title="Leggi i metadati"
              loading={loading}
              disabled={getReportDownload.isLoading}
              aria-label="Leggi i metadati del report"
              onClick={() => setHeaderFunction(metadati_val ? metadati_val : {"id_funzione":funzione?.id, "titolo_report":tempSubTitle})}
              icon={<FontAwesomeIcon aria-hidden="false" alt="" icon={faCircleInfo} size="xl" />}></Button>
            {/*
            <Button
              tabIndex="0"
              loading={loadingPDF}
              disabled={loading || getReportDownload.isLoading}
              title=" Scarica PDF"
              aria-label="Scarica tabella report in PDF"
              onClick={async () => {
                setLoadingPDF(true);
                await GetReportDownload('PDF');
                setLoadingPDF(false);
              }}
              icon={<FontAwesomeIcon aria-hidden="false" alt="" icon={faFilePdf} size="xl" />}></Button>
            */}
            <Button
              tabIndex="0"
              title=" Scarica XLSX"
              loading={loadingXLSX}
              disabled={loading || getReportDownload.isLoading}
              aria-label="Scarica tabella report in XLSX"
              onClick={async () => {
                setLoadingXLSX(true);
                await GetReportDownload('XLSX');
                setLoadingXLSX(false);
              }}
              icon={<FontAwesomeIcon aria-hidden="false" alt="" icon={faFileExcel} size="xl" />}></Button>
            <Button
              tabIndex="0"
              title=" Scarica CSV"
              loading={loadingCSV}
              disabled={loading || getReportDownload.isLoading}
              aria-label="Scarica tabella report in CSV"
              onClick={async () => {
                setLoadingCSV(true);
                await GetReportDownload('CSV');
                setLoadingCSV(false);
              }}
              icon={<FontAwesomeIcon aria-hidden="false" alt="" icon={faFileLines} size="xl" />}></Button>
            <Button
              tabIndex="0"
              title=" Scarica JSON"
              loading={loadingJSON}
              disabled={loading || getReportDownload.isLoading}
              aria-label="Scarica tabella report in JSON"
              onClick={async () => {
                setLoadingJSON(true);
                await GetReportDownload('JSON');
                setLoadingJSON(false);
              }}
              icon={<FontAwesomeIcon aria-hidden="false" alt="" icon={faFileCode} size="xl" />}></Button>
          </div>
        </div>
        {tempPeriodoDate && <p>Periodo dati: {`${tempPeriodoDate[0]} - ${tempPeriodoDate[1]}`}</p>}
      </div>
      {tempDesc && <p id="descrizione">{tempDesc}</p>}
      <div role="search" aria-label="Filtri della tabella" className="filtri">
        <div id="DataPickerZone">
          <div className="DataPickerDiv">
            {fromHome && homeDataPicker == 'al' ? (
              <p>Al:</p>
            ) : homeDataPicker == 'dal' ? (
              <p>Dal:</p>
            ) : (
              <p>Da:</p>
            )}
            <DatePicker
              suffixIcon={false}
              allowClear={false}
              defaultValue={moment(tmpDates.dataDaUp, LF_API)}
              value={moment(tmpDates.dataDaUp)}
              format={LF}
              disabled={isEditable === false}
              disabledDate={(d) =>
                !d ||
                d.isBefore(moment(tempPeriodoDate[0], 'DD/MM/YYYY')) ||
                d.isAfter(moment(tempPeriodoDate[1], 'DD/MM/YYYY')) ||
                (tmpDates.dataAUp && d.isAfter(moment(tmpDates.dataAUp, LF_API)))
              }
              onChange={(MomentObj) => {
                setTmpDates({ ...tmpDates, dataDaUp: MomentObj.format(LF_API) });
              }}
            />
          </div>
          {tmpDates.dataAUp && (
            <div className="DataPickerDiv">
              <p>A:</p>
              <DatePicker
                suffixIcon={false}
                allowClear={false}
                defaultValue={moment(tmpDates.dataAUp, LF_API)}
                value={moment(tmpDates.dataAUp)}
                format={LF}
                disabledDate={(d) =>
                  !d ||
                  d.isBefore(moment(tempPeriodoDate[0], 'DD/MM/YYYY')) ||
                  d.isAfter(moment(tempPeriodoDate[1], 'DD/MM/YYYY')) ||
                  (tmpDates.dataDaUp && d.isBefore(moment(tmpDates.dataDaUp, LF_API)))
                }
                onChange={(MomentObj) => {
                  setTmpDates({ ...tmpDates, dataAUp: MomentObj.format(LF_API) });
                }}
              />
            </div>
          )}
        </div>
        <div id="filterZone">
          <Form id="formRicerca">
            <Form.Group controlId="valueSelect" className="form-group">
              <Form.Label htmlFor="selectid">Variabile</Form.Label>
              <Select
                tabIndex="0"
                id="selectid"
                showSearch
                placeholder="Scegli la colonna"
                optionFilterProp="children"
                value={currFilterValue}
                dropdownMatchSelectWidth={false}
                onChange={(getSelectValue) => {
                  setCurrFilterValue(getSelectValue);
                  setCurrColumnValue('');
                  setCurrColumnDataIndex(getSelectValue);
                  GetAutocompleteData(getSelectValue);
                }}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={selectOption}
                disabled={isChangingDateFilter()}
              />
            </Form.Group>
            <Form.Group controlId="valueInput" className="form-group">
              <Form.Label htmlFor="valoreid">Valore 
                {searchIsLoading && 
                  <span class="ant-btn-loading-icon" style={{color:"red", position:"relative", left:"8px"}} aria-hidden="true">
                    <span role="img" aria-label="loading" class="anticon anticon-loading anticon-spin">
                      <svg viewBox="0 0 1024 1024" focusable="false" data-icon="loading" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                        <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                      </svg>
                    </span>
                  </span>
                }
              </Form.Label>
              <Select
                showSearch
                tabIndex={0}
                id="valoreid"
                value={currColumnValue || currColumnSearch}
                disabled={autocompleteIsLoading || isChangingDateFilter()}
                options={autoDataFiltered || autoData}
                className="form-control"
                onSelect={(_, obj) => {
                  setCurrColumnValue(obj?.value);
                }}
                onSearch={(inputValue) => {
                  setCurrColumnValue(null);
                  setCurrColumnSearch(inputValue);
                  if (inputValue.length) {
                    setAutoDataFiltered((autoData || [])
                        .filter(i => i.value.toString().toUpperCase().indexOf(inputValue.toUpperCase()) !== -1)
                        .map((v) => ({ label: v.label, value: v.value, key: v.key })));
                  } else {
                    setAutoDataFiltered(null);
                  }
                }}
              />
            </Form.Group>
          </Form>
          <Button
            aria-disabled="true"
            tabIndex={0}
            disabled={searchIsLoading}
            onClick={() => {
              const { dataDaUp, dataAUp } = tmpDates;
              setSelectedPage(1);
              setPaginationHelper(false);
              if (currFilterValue && !isChangingDateFilter()) {
                dispatch(
                  updateTextFilters({
                    filterFields: [
                      ...textFilters.filterFields,
                      {
                        textFields: currColumnDataIndex,
                        textValue: currColumnValue ?
                          //se con valore
                          typeof(currColumnValue) === "string" ? 
                            currColumnValue.replaceAll("'", "''")
                            : currColumnValue
                          //se vuoto
                          : "$BLANK$",
                        i:
                          textFilters.filterFields.length === 0
                            ? 0
                            : textFilters.filterFields.length + 1
                      }
                    ]
                  })
                );
                setCurrFilterValue(null);
                setCurrColumnDataIndex(null);
                setCurrColumnValue('');
                GetAutocompleteData(null);

              } else {
                if ((currFilterValue && currColumnValue) || (isChangingDateFilter())) {
                  //GetTableData({ selectedPage });
                  updateUrlParam({ dateFrom: dataDaUp, dateTo: dataAUp });
                } else {
                  notification.open({
                    message: 'Filtri non applicati',
                    description:
                      'Non è disponibile nessun filtro da applicare, assicurati di aver applicato modifiche ai filtri',
                    duration: 4
                  });
                }
              }
              if (currFilterValue || currColumnValue) {
                setCurrFilterValue(null);
                setCurrColumnDataIndex(null);
                setCurrColumnValue('');
                GetAutocompleteData(null);
              }
            }}
            htmlType="submit">
            Applica
          </Button>
        </div>
      </div>
      <div className="chipsZone">
        {textFilters.filterFields.length > 0 && (
          <>
            <p>Filtri attivi:</p>
            <div className="chips">
              {textFilters.filterFields.map((field, i) => {
                return (
                  <Tag
                    tabIndex="0"
                    closable
                    key={i}
                    onKeyDown={(e) => {
                      if (e.key === "Enter"){
                        setSelectedPage(1);
                        setPaginationHelper(false);
                        const tmpArr = [...textFilters.filterFields];
                        tmpArr.splice(i, 1);
                        dispatch(updateTextFilters({ filterFields: tmpArr }));
                        if (currFilterValue || currColumnValue) {
                          setCurrFilterValue(null);
                          setCurrColumnDataIndex(null);
                          setCurrColumnValue('');
                          GetAutocompleteData(null);
                        }
                      }
                    }}
                    onClose={() => {
                      setSelectedPage(1);
                      setPaginationHelper(false);
                      const tmpArr = [...textFilters.filterFields];
                      tmpArr.splice(i, 1);
                      dispatch(updateTextFilters({ filterFields: tmpArr }));
                      if (currFilterValue || currColumnValue) {
                        setCurrFilterValue(null);
                        setCurrColumnDataIndex(null);
                        setCurrColumnValue('');
                        GetAutocompleteData(null);
                      }
                    }}
                  >
                    <b>{`${tableData.label[tableData.colNames.indexOf(`${field.textFields}`)]}:`}&nbsp;</b>
                    {`${Utils.truncateEllipsis(field.textValue === "$BLANK$" ? "Non disponibile" : field.textValue)}`}
                    
                  </Tag>
                );
              })}
            </div>
          </>
        )}
      </div>

      <div id="tableReportDiv">
        {tableData && paginationHelper && (
          <>
            <div id="tableid">
              <ConfigProvider
                renderEmpty={() => (
                  <Empty description="Nessun risultato trovato" imageStyle={{ display: 'none' }} />
                )}>
                <AntdTableScrollXaxisTop className="scrollbar">
                  <Table
                    loading={getSpoolData.isLoading}
                    columns={columns}
                    dataSource={tableData.body?.map((row, i) => ({
                      ...row,
                      key: `${i}`
                    }))}
                    scroll={{ x: true }}
                    pagination={{
                      total: tableData.totalRows,
                      defaultCurrent: 1,
                      onChange: paginationChange,
                      showTotal: (total, range) => {
                        return `${range[0]}-${range[1]} di ${total}`;
                        },
                    }}
                  />
                </AntdTableScrollXaxisTop>
              </ConfigProvider>
            </div>
          </>
        )}
      </div>
      <ReportHead
        headerFunction={headerFunction}
        setHeaderFunction={setHeaderFunction}
        setLoading={setLoading}
        date={data.dataDaUp}
      />
    </Spin>
  );
};

export default BodyCompiler;
